<template>
  <SidebarShell>
    <template #sidebar="{ variant }">
      <GestionSidebar :variant="variant" />
    </template>
    <slot></slot>
  </SidebarShell>
</template>
